// Plan 1a Welle 1, MA-06 (PLAN-1A.md 2.2, welle-1/AUFTEILUNG.md 2): die Geldwörter an einer Stelle.
// Spur kontingent, KO-20 (SPEC-KONTINGENT.md 4.0, KT-01): Kundenfirmen sehen ein Kontingent in Prozent, kein KI-Guthaben in
// Euro. Die neuen Schlüssel stehen neben den alten; kiGuthaben, zusatzGuthaben und verbrauch entfallen erst, wenn eine Suche
// ohne Grenze keinen Leser mehr zeigt (welle-2/kontingent/AUFTEILUNG.md R7, S3-9). Am 11.10.2026 lesen sie noch
// welle0-geld.test.mjs (kiGuthaben), BillingPanel.tsx und welle1-geld.test.mjs (zusatzGuthaben) und CostPanel.tsx (verbrauch);
// kiGuthabenSatz und zuteilen hatten keinen Leser mehr und sind entfernt.
export const GELD = {
  kontingent: 'Kontingent',
  kontingentSatz: 'Die KI-Nutzung, die im Preis enthalten ist. Beginnt jeden Monat neu; ein Rest verfällt.',
  zusatzKontingent: 'Zusatzkontingent',
  verwendet: 'Vom Kontingent verwendet',
  kiGuthaben: 'KI-Guthaben',
  zusatzGuthaben: 'Zusätzliches Guthaben',
  zusatzSatz: 'Wird extra in Rechnung gestellt.',
  // Spur guthaben (SPEC-KONTINGENT.md 14.1 Punkte 2 und 4; welle-2/guthaben/AUFTEILUNG.md GU-31, W-S11, PE-8): jeder Kaufweg
  // heißt wie der Knopf im Bereich „Zusätzliches Guthaben“; „Zusatzkontingent kaufen“ ist alt.
  zusatzKaufen: 'Guthaben aufladen …',
  zuteilenSatz: 'Aus dem Kontingent der Firma, nur für diesen Monat, ohne Zusatzkosten.',
  mehrGeben: 'Für diesen Monat mehr geben',
  verbrauch: 'Verbrauch',
  verbrauchSatz: 'So viel ist diesen Monat verwendet. Es kommt aus dem im Preis enthaltenen Kontingent und kostet nichts extra.',
  verbrauchsliste: 'Verbrauchsliste',
  kiAnfragen: 'Anfragen an die KI',
  ohneAnzahlgrenze: 'ohne Anzahlgrenze',
  persoenlicheGrenze: 'Persönliche Grenze im Monat',
  vorgabeDerFirma: 'Vorgabe der Firma',
  festeObergrenze: 'feste Obergrenze',
  tabelleHerunterladen: 'Als Tabelle herunterladen (für Excel)',
  tabelleExportieren: 'Als Tabelle exportieren (für Excel)',
  sso: 'Anmeldungen über Ihr Firmenkonto (SSO)',
  anbieter: 'Anbieter von CLAiRIS',
  monatsSatz: 'Recherchen im Monat zählen gestartete Recherchen; das Kontingent misst, wie umfangreich sie waren. Beide gelten je Kalendermonat.',
  // F-15 Punkt 7 (PF-752b): der Monat wechselt am 1. um 00:00 Europe/Vienna (billing/kontingentMonat.ts).
  monatsbeginnSatz: 'Ein neuer Kalendermonat beginnt am 1. um 0 Uhr österreichischer Zeit.',
  // F-15 Punkt 3 (BAU-GELD.md 1.3, PF-757a-nach-2): die Antwort auf „Woher kommt es?“ im Aufklapper „Wie funktioniert das
  // Kontingent?“ (kontingentErklaerung.ts); die Uhrzeit des Monatsbeginns steht nur in dieser Datei (geldwoerter.test.mjs O2-3).
  kontingentNeuSatz: 'Das Kontingent ist im Preis Ihres Tarifs enthalten und beginnt am 1. jedes Monats um 0 Uhr neu.',
  // F-23 (PF-NB-geld-1, SPEC-geld Befund 3): die interne Organisation des Betriebs hat keinen Tarif, kein Abo und keine Rechnung.
  tarifIntern: 'Ohne Tarif (interne Organisation)',
  internOhneRechnung: 'Ohne Zahlung und ohne Rechnung.',
  rechnungIntern: 'Die interne Organisation des Betriebs hat keinen Vertrag und bekommt keine Rechnungen.',
  // F-23 (PF-NB-geld-2): ohne Zahlungsabo (vom Anbieter freigeschaltet) ist nichts „schon bezahlt“.
  ohneMehrkosten: 'ohne Mehrkosten.',
  freierPlatzOhneKosten: 'Ein freier Platz kostet nichts extra.',
} as const;
export const hoechstensRecherchen = (anzahl: number) => `höchstens ${anzahl.toLocaleString('de-AT')}`;
